const projectsArray = [
    {
        name: 'ClimUp',
        desc: 'Simple weather app, developed just for fun. Features a 7 day forecast of up to 5 cities of the world at a time, with slightly detailed climatic conditions.',
        visit: 'https://climup.vercel.app/',
        code: 'https://github.com/pruscius/ClimUp',
        date: `January '22`,
        role: 'Front-End Developer.',
        tools: ['React', 'Redux', 'OpenWeatherMap API']
    },
    {
        name: 'EventIn',
        desc: 'Mobile event app, developed as a final group project of the Soy Henry Bootcamp. The purpose of this project was to bring people closer to social and cultural events as the world came out of quarantine.',
        code: 'https://github.com/facuparedes/EventIn',
        youTube: 'https://www.youtube.com/watch?v=XYkslUE_vKg',
        scanQr: 'https://expo.dev/@andyfrank/proyecto-grupal',
        date: `November '21`,
        role: 'Full-stack Developer.',
        tools: ['React Native', 'Firebase', 'Express', 'Mercado Pago SDK', 'Google Places & Geolocation API']
    },
    {
        name: 'Countrivities',
        desc: 'Web app developed as an individual project challenge in the context of the Soy Henry Bootcamp, intended to inform about touristic activities related to the different countries of the world.',
        visit: 'https://countrivities.vercel.app/',
        code: 'https://github.com/pruscius/PI_Countries',
        date: `October '21`,
        role: 'Full-stack Developer.',
        tools: ['React', 'Express', 'PostgreSQL', 'Sequelize']
    }
]

export default projectsArray;